<!--suppress TypeScriptUnresolvedVariable, TypeScriptUnresolvedFunction -->
<div fxLayout="column" class="meteo-config-container">
    <div fxLayout="row">
        <form novalidate [formGroup]="form" fxLayout="column" fxLayoutGap="0.5rem" fxFlex="50" class="meteo-form">
            <div class="txt-h-20-7">{{'Access details'|i18n}}</div>
            <div fxLayout="row" fxLayoutAlign="start center" class="mt-20">
                <div fxFlex="33" class="txt-p-16-4">{{'Type'|i18n}}:</div>
                <div class="txt-p-16-4">{{cfg.type|connectorType}}</div>
            </div>
<!--            <div fxLayout="row" fxLayoutAlign="start center">-->
<!--                <div fxFlex="33" class="txt-p-16-4">{{'Source'|i18n}}:</div>-->
<!--                <mat-select app-small-select formControlName="srcType" fxFlex="60" class="txt-p-16-4"-->
<!--                            (selectionChange)="onSourceTypeChange($event)">-->
<!--                    <mat-option *ngFor="let srcType of METEO_SRC_TYPES" [value]="srcType" class="txt-p-16-4">-->
<!--                        {{srcType|meteoSourceType}}-->
<!--                    </mat-option>-->
<!--                </mat-select>-->
<!--                <div *ngIf="!form.controls.srcType.valid" class="ml-10 txt-a-16-7">-->
<!--                    {{'Invalid source'|i18n}}-->
<!--                </div>-->
<!--            </div>-->
            <ng-container [ngSwitch]="form.controls.srcType.value">
                <ng-container *ngSwitchCase="SourceType.METEOMATICS">
                    <div app-input-container class="mt-8" fxLayout="row" fxLayoutAlign="start center">
                        <div fxFlex="33" class="txt-p-16-4">{{'API url'|i18n}}:</div>
                        <input app-input formControlName="apiUrl" fxFlex="60" class="txt-p-16-4"
                               [maxLength]="HOST_MAX_CHARS">
                        <div *ngIf="!form.controls.apiUrl.valid" class="ml-10 txt-a-16-7">
                            {{'Invalid API url'|i18n}}
                        </div>
                    </div>
                    <div app-input-container fxLayout="row" fxLayoutAlign="start center">
                        <div fxFlex="33" class="txt-p-16-4">{{'User name'|i18n}}:</div>
                        <input app-input formControlName="user" autocomplete="username" fxFlex="60" class="txt-p-16-4"
                               [maxLength]="DEFAULT_MAX_CHARS">
                        <div *ngIf="!form.controls.user.valid" class="ml-10 txt-a-16-7">
                            {{'Invalid user name'|i18n}}
                        </div>
                    </div>
                    <div app-input-container fxLayout="row" fxLayoutAlign="start center">
                        <div fxFlex="33" class="txt-p-16-4">{{'Password'|i18n}}:</div>
                        <input app-input formControlName="pass" type="password"
                               fxFlex="60" class="txt-p-16-4" [maxLength]="DEFAULT_MAX_CHARS"
                               (click)="onPasswordControlInteraction()"
                               (keydown)="onPasswordControlInteraction()">
                        <div *ngIf="!form.controls.pass.valid" class="ml-10 txt-a-16-7">
                            {{'Invalid password'|i18n}}
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </form>
    </div>
    <div fxLayout="column" class="locations-panel mt-30">
        <div class="txt-h-20-7">{{'Meteo locations list'|i18n}}</div>
        <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-22 mb-32">
            <div app-input-container class="location-search-container">
                <input app-input #deviceSearch class="location-search" [formControl]="deviceSearchCtrl"
                       [matAutocomplete]="deviceSearchAutocomplete" [spellcheck]="false"
                       [placeholder]="'Search location by ID'|i18n"
                       (focusout)="onDeviceSearchLoseFocus($event)">
                <app-icon *ngIf="!!deviceSearchCtrl.value" name="fal-times" class="right-symbol clear"
                          (click)="onClickResetDeviceSearch()">
                </app-icon>
                <mat-autocomplete #deviceSearchAutocomplete="matAutocomplete"
                                  [displayWith]="displaySearchDevice.bind(this)"
                                  (optionSelected)="onSelectSearchDevice($event)">
                    <mat-option *ngFor="let filteredVdevCfg of filteredDevices|async; trackBy: trackByVdevId"
                                [value]="filteredVdevCfg"
                                data-connectorDevice="true">
                        {{filteredVdevCfg.vdevId}}
                    </mat-option>
                </mat-autocomplete>
                <svg *ngIf="!deviceSearchCtrl.value" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                     class="right-symbol mag-glass">
                    <!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                    <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z"/>
                </svg>
            </div>
            <button app-primary-button class="add-vdev-button"
                    (click)="onClickAddVirtualDevice()">
                <app-icon name="fal-plus-square"></app-icon>
                {{'Add meteo location'|i18n}}
            </button>
        </div>
        <ng-container *appVar="pagedVDevs|async as vDevs">
            <div *ngIf="vDevs && !selectedDev" class="accordion-panel">
                <mat-accordion>
                    <mat-expansion-panel *ngFor="let vdev of vDevs.data; trackBy: trackByVdevId"
                                         togglePosition="before" class="exp-panel"
                                         [expanded]="vdev.vdevId === vDevToExpand">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <div class="txt-h-16-5">{{vdev.vdevId}}</div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ng-container *ngTemplateOutlet="vdevDetails; context: {vdev: vdev}">
                        </ng-container>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
            <mat-paginator #paginator app-paginator class="meteo-paginator"
                           [ngClass]="{'collapsed': !vDevs || vDevs.total === 0 || !!selectedDev}"
                           [length]="vDevs?.total" [pageSize]="PAGE_SIZE"
                           [pageSizeOptions]="PAGE_SIZES">
            </mat-paginator>
            <div *ngIf="selectedDev" class="accordion-panel">
                <ng-container *ngTemplateOutlet="vdevDetails; context: {vdev: selectedDev}">
                </ng-container>
            </div>
            <ng-template #vdevDetails let-vdev="vdev">
                <div fxLayout="row" fxLayoutAlign="start center" class="txt-h-16-5 mb-10">
                    <app-icon name="fal-map-marker-alt" fxLayoutAlign="start" fxFlex="2"></app-icon>
                    <div>{{('ID'|i18n) + ': ' + vdev.vdevId}}</div>
                </div>
                <div fxLayout="row">
                    <div fxFlex="2"></div>
                    <div fxFlex fxLayout="row">
                        <form novalidate [formGroup]="vdev.form" class="vdev-form" fxLayout="row"
                              fxLayoutAlign="start center" fxFlex="70">
                            <div app-input-container fxLayout="row" fxLayoutAlign="start center"
                                 class="coordinate-field" fxLayoutGap="30px" fxFlex="30">
                                <div class="txt-p-16-4" fxFlex="30">{{'Latitude'|i18n}}:</div>
                                <input app-input formControlName="latitude" type="number" class="txt-p-16-5"
                                       fxFlex="50" [maxLength]="DEFAULT_MAX_CHARS">
                            </div>
                            <div app-input-container fxLayout="row" fxLayoutAlign="start center"
                                 class="coordinate-field" fxLayoutGap="30px" fxFlex="30">
                                <div class="txt-p-16-4" fxFlex="30">{{'Longitude'|i18n}}:</div>
                                <input app-input formControlName="longitude" type="number" class="txt-p-16-5"
                                       fxFlex="50" [maxLength]="DEFAULT_MAX_CHARS">
                            </div>
                            <div app-input-container fxLayout="row" fxLayoutAlign="start center"
                                 class="duration-field" fxFlex="30">
                                <div class="txt-p-16-4" fxFlex="30">{{'Duration'|i18n}}:</div>
                                <input app-input formControlName="duration" type="number"
                                       class="txt-p-16-5 mr-10" fxFlex="35" [maxLength]="DEFAULT_MAX_CHARS">
                                <div class="txt-p-16-4">{{'hours'|i18n}}</div>
                            </div>
                        </form>
                        <div fxLayout="row">
                            <button mat-stroked-button class="polling-policy-btn"
                                    [title]="'Polling policy'|i18n"
                                    (click)="onClickVirtualDevicePollingPolicy(vdev.vdevId)">
                                <div class="polling-policy-text">
                                    <app-icon name="fal-stopwatch"></app-icon>&nbsp;
                                    {{cfg.devices[vdev.vdevId]|pollingPolicy}}
                                </div>
                            </button>
                        </div>
                        <div fxFlex="5"></div>
                        <div fxLayoutAlign="start" fxLayoutGap="0.5rem">
                            <button class="operation-button" [title]="'Add measure'|i18n"
                                    (click)="onClickVirtualDeviceAddMeasure(vdev)">
                                <app-icon name="fal-plus-square"></app-icon>
                            </button>
                            <button class="operation-button" [title]="'Advanced settings'|i18n"
                                    (click)="onClickVirtualDeviceAdvancedSettings(vdev)">
                                <app-icon name="fal-tools"></app-icon>
                            </button>
                            <button *ngIf="vdev.newlyCreated" class="operation-button"
                                    [title]="'Rename location'|i18n"
                                    (click)="onClickRenameVirtualDevice(vdev)">
                                <app-icon name="fal-edit"></app-icon>
                            </button>
                            <button class="operation-button warn" [title]="'Remove location'|i18n"
                                    (click)="onClickDeleteVirtualDevice(vdev)">
                                <app-icon name="fal-trash-alt"></app-icon>
                            </button>
                        </div>
                    </div>
                    <div fxFlex="2"></div>
                </div>
                <div fxLayout="row">
                    <div fxFlex="2"></div>
                    <div fxFlex fxLayout="row">
                        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="70">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px" fxFlex="30">
                                <div fxFlex="30"></div>
                                <div class="txt-a-16-7" fxFlex="50">
                                    <div [style.visibility]="!vdev.form.controls.latitude.valid &&
                                                    vdev.form.controls.latitude.touched ? 'visible' : 'hidden'">
                                        {{'Invalid latitude'|i18n}}
                                    </div>
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px" fxFlex="30">
                                <div fxFlex="30"></div>
                                <div class="txt-a-16-7" fxFlex="50">
                                    <div [style.visibility]="!vdev.form.controls.longitude.valid &&
                                                    vdev.form.controls.longitude.touched ? 'visible' : 'hidden'">
                                        {{'Invalid longitude'|i18n}}
                                    </div>
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="30">
                                <div fxFlex="30"></div>
                                <div class="txt-a-16-7" fxFlex="50">
                                    <div [style.visibility]="!vdev.form.controls.duration.valid ? 'visible' : 'hidden'">
                                        {{'Invalid duration'|i18n}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div fxFlex="2"></div>
                </div>
                <div *ngIf="getVdevMeasures(vdev) as measures" class="measures-panel mt-10">
                    <div class="txt-h-20-7 mb-20">{{'Measures for location {0}'|i18n:vdev.vdevId}}</div>
                    <div fxLayout="row" fxLayoutAlign="start center" class="txt-d-16-7 mb-20">
                        <div fxLayoutAlign="end" fxFlex="30">{{'Measure name'|i18n}}</div>
                        <div fxFlex="1"></div>
                        <div fxLayoutAlign="start center" fxFlex>
                            <div fxLayoutAlign="start" fxFlex>{{'Measure type'|i18n}}</div>
                            <div fxFlex="2"></div>
                            <div fxLayoutAlign="start" fxFlex="25">{{'Unit of measure'|i18n}}</div>
                        </div>
                        <div fxFlex="1"></div>
                        <div fxFlex="25"></div>
                    </div>
                    <div *ngFor="let meas of getVdevMeasures(vdev); trackBy: trackByMeasId" fxLayout="column">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <div fxLayoutAlign="end" fxFlex="30" class="txt-p-16-4">{{meas.measId}}</div>
                            <div fxFlex="1"></div>
                            <form novalidate [formGroup]="meas.form" class="measure-form" fxLayout="row"
                                  fxLayoutAlign="start" fxFlex>
                                <div fxLayout="column" fxFlex>
                                    <mat-select app-small-select placeholder="{{'Measure type'|i18n}}"
                                                formControlName="type" class="txt-p-16-4"
                                                (selectionChange)="onMeasureTypeChange(vdev, meas, $event)">
                                        <mat-option *ngFor="let measType of METEO_MEASURE_TYPES"
                                                    [value]="measType"
                                                    [disabled]="hasMeasure(vdev, meas, measType)"
                                                    class="txt-p-16-4">
                                            {{measType|meteoMeasureType|i18n}}
                                        </mat-option>
                                    </mat-select>
                                </div>
                                <div fxFlex="2"></div>
                                <div app-input-container class="uom-field" fxLayout="column"
                                     fxLayoutAlign="start"
                                     fxFlex="25">
                                    <input app-input formControlName="uom" [title]="'Unit of measure'|i18n"
                                           class="txt-p-16-4" [maxLength]="DEFAULT_MAX_CHARS">
                                </div>
                            </form>
                            <div fxFlex="1"></div>
                            <div fxLayoutAlign="start" fxFlex="25" fxLayoutGap="0.5rem">
                                <button class="operation-button" [title]="'Advanced settings'|i18n"
                                        [disabled]="!advancedSettingsEnabled(vdev, meas)"
                                        (click)="onClickMeasureAdvancedSettings(vdev, meas)">
                                    <app-icon name="fal-tools"></app-icon>
                                </button>
                                <button *ngIf="meas.newlyCreated" class="operation-button"
                                        [title]="'Rename measure'|i18n"
                                        (click)="onClickRenameMeasure(vdev, meas.measId)">
                                    <app-icon name="fal-edit"></app-icon>
                                </button>
                                <button class="operation-button warn" [title]="'Remove measure'|i18n"
                                        (click)="onClickDeleteMeasure(vdev, meas.measId)">
                                    <app-icon name="fal-trash-alt"></app-icon>
                                </button>
                            </div>
                        </div>
                        <div fxLayout="row">
                            <div fxLayoutAlign="end" fxFlex="30"></div>
                            <div fxFlex="1"></div>
                            <div fxLayout="row" fxLayoutAlign="start" fxFlex>
                                <div fxLayout="column" fxFlex>
                                    <div [style.visibility]="!meas.form.controls.type.valid ? 'visible' : 'hidden'"
                                         class="txt-a-16-7">
                                        {{'Invalid measure type'|i18n}}
                                    </div>
                                </div>
                                <div fxFlex="2"></div>
                                <div fxLayout="column" fxLayoutAlign="start" fxFlex="40">
                                    <div [style.visibility]="(!meas.form.controls.uom.valid &&
                                                 !meas.form.controls.uom.disabled) ? 'visible' : 'hidden'"
                                         class="txt-a-16-7">
                                        {{'Invalid unit of measure'|i18n}}
                                    </div>
                                </div>
                            </div>
                            <div fxLayoutAlign="start" fxFlex="15"></div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </ng-container>
    </div>
</div>

<ng-template #addVirtualDevice let-data>
    <h1 mat-dialog-title>{{'Add location'|i18n}}</h1>
    <div mat-dialog-content fxLayout="column">
        <form fxLayout="column">
            <mat-form-field class="mr-16">
                <input matInput [placeholder]="'Id'|i18n" [formControl]="data['idFormControl']"
                       [maxLength]="ID_MAX_CHARS">
                <mat-error *ngIf="data['idFormControl'].hasError('empty')">
                    {{'Id not valid'|i18n}}
                </mat-error>
                <mat-error *ngIf="data['idFormControl'].hasError('duplicate')">
                    {{'Id already exists'|i18n}}
                </mat-error>
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data['idFormControl'].valid"
                [mat-dialog-close]="data['idFormControl'].value">
            <app-icon name="fal-plus-square"></app-icon>&nbsp;&nbsp;
            {{'Add'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #renameVirtualDevice let-data>
    <h1 mat-dialog-title>{{'Rename {0}'|i18n:data['vdevId']}}</h1>
    <div mat-dialog-content fxLayout="column" class="rename-vdev">
        <form fxLayout="column">
            <mat-form-field class="mr-16">
                <input matInput [placeholder]="'Id'|i18n" [formControl]="data['idFormControl']"
                       [maxLength]="ID_MAX_CHARS">
                <mat-error *ngIf="data['idFormControl'].hasError('empty')">
                    {{'Id not valid'|i18n}}
                </mat-error>
                <mat-error *ngIf="data['idFormControl'].hasError('duplicate')">
                    {{'Id already exists'|i18n}}
                </mat-error>
            </mat-form-field>
        </form>
        <span *ngIf="data['relatedMeasures'].length" class="related-measures">
            {{'Measures related to {0}'|i18n:data['vdevId']}}:
            {{(data['relatedMeasures']|sortArray).join(', ')}}
        </span>
        <span *ngIf="!data['relatedMeasures'].length" class="related-measures">
            {{'No devices connected to {0}'|i18n:data['vdevId']}}
        </span>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-8">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data['idFormControl'].valid"
                [mat-dialog-close]="data['idFormControl'].value">
            <app-icon name="fal-save"></app-icon>&nbsp;&nbsp;
            {{'Rename'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #deleteVirtualDevice let-data>
    <h1 mat-dialog-title>{{'Delete {0}'|i18n:data['vdevId']}}</h1>
    <div mat-dialog-content fxLayout="column" class="delete-vdev">
        <span>{{'Are you sure you want to delete {0} along with all its measures?'|i18n:data['vdevId']}}</span>
        <span *ngIf="data['relatedMeasures'].length" class="related-measures mt-16">
            {{'Measures related to {0}'|i18n:data['vdevId']}}:
            {{(data['relatedMeasures']|sortArray).join(', ')}}
        </span>
        <span *ngIf="!data['relatedMeasures'].length" class="related-measures mt-16">
            {{'No devices connected to {0}'|i18n:data['vdevId']}}
        </span>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-8">
        <button mat-stroked-button color="warn" type="submit"
                [mat-dialog-close]="true">
            <app-icon name="fal-trash-alt"></app-icon>&nbsp;&nbsp;
            {{'Delete'|i18n}}
        </button>
    </div>
</ng-template>


<ng-template #advancedVirtualDeviceSettings let-data>
    <h1 mat-dialog-title>{{'Advanced settings for {0}'|i18n:data['vdevId']}}</h1>
    <div mat-dialog-content fxLayout="column" class="vdev-advanced-settings">
        <form novalidate [formGroup]="data['form']" fxLayout="column">
            <mat-form-field>
                <input matInput placeholder="{{'Offset'|i18n}}" formControlName="offset" type="number"
                       [maxLength]="DEFAULT_MAX_CHARS">
                <span matSuffix>{{'hours'|i18n}}</span>
                <mat-error *ngIf="!data['form'].controls.offset.valid">
                    {{'Invalid offset'|i18n}}
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <input matInput placeholder="{{'Granularity'|i18n}}" formControlName="granularity" type="number"
                       [maxLength]="DEFAULT_MAX_CHARS">
                <span matSuffix>{{'seconds'|i18n}}</span>
                <mat-error *ngIf="!data['form'].controls.granularity.valid">
                    {{'Invalid granularity'|i18n}}
                </mat-error>
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data.form.valid || !data.form.dirty"
                [mat-dialog-close]="true">
            <app-icon name="fal-save"></app-icon>&nbsp;&nbsp;
            {{'Ok'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #addMeasure let-data>
    <h1 mat-dialog-title>{{'Add measure'|i18n}}</h1>
    <div mat-dialog-content fxLayout="column">
        <form fxLayout="column">
            <mat-form-field class="mr-16">
                <input matInput [placeholder]="'Id'|i18n" [formControl]="data['idFormControl']"
                       [maxLength]="ID_MAX_CHARS">
                <mat-error *ngIf="data['idFormControl'].hasError('empty')">
                    {{'Id not valid'|i18n}}
                </mat-error>
                <mat-error *ngIf="data['idFormControl'].hasError('duplicate')">
                    {{'Id already exists'|i18n}}
                </mat-error>
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data['idFormControl'].valid"
                [mat-dialog-close]="data['idFormControl'].value">
            <app-icon name="fal-plus-square"></app-icon>&nbsp;&nbsp;
            {{'Add'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #renameMeasure let-data>
    <h1 mat-dialog-title>{{'Rename {0}'|i18n:data['measId']}}</h1>
    <div mat-dialog-content fxLayout="column">
        <form fxLayout="column">
            <mat-form-field>
                <input matInput [placeholder]="'Id'|i18n" [formControl]="data['idFormControl']"
                       [maxLength]="ID_MAX_CHARS">
                <mat-error *ngIf="data['idFormControl'].hasError('empty')">
                    {{'Id not valid'|i18n}}
                </mat-error>
                <mat-error *ngIf="data['idFormControl'].hasError('duplicate')">
                    {{'Id already exists'|i18n}}
                </mat-error>
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data['idFormControl'].valid"
                [mat-dialog-close]="data['idFormControl'].value">
            <app-icon name="fal-save"></app-icon>&nbsp;&nbsp;
            {{'Rename'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #deleteMeasure let-data>
    <h1 mat-dialog-title>{{'Delete {0}'|i18n:data['measId']}}</h1>
    <div mat-dialog-content fxLayout="column">
        <span>{{'Are you sure you want to delete {0}?'|i18n:data['measId']}}</span>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-16">
        <button mat-stroked-button color="warn" type="submit"
                [mat-dialog-close]="true">
            <app-icon name="fal-trash-alt"></app-icon>&nbsp;&nbsp;
            {{'Delete'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #advancedMeasureSettings let-data>
    <h1 mat-dialog-title>{{'Advanced settings for {0}'|i18n:data['measId']}}</h1>
    <div mat-dialog-content fxLayout="column" class="advanced-settings">
        <form novalidate [formGroup]="data['form']" fxLayout="column">
            <span class="expression-label">
                {{'Expression'|i18n}}
            </span>
            <app-expression-editor formControlName="expression"
                                   [features]="data['features']">
            </app-expression-editor>
            <span *ngIf="!data['form'].controls.expression.valid" class="expression-error">
                {{'Invalid expression'|i18n}}
            </span>
        </form>
        <div fxLayout="row" fxLayoutAlign="end" class="mt-8">
            <app-icon name="fal-question-circle" class="expression-help"
                      [matTooltip]="'expression-hint__{meteo}'|i18n"
                      matTooltipClass="fs-1">
            </app-icon>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-16">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data.form.valid || !data.form.dirty"
                [mat-dialog-close]="true">
            <app-icon name="fal-save"></app-icon>&nbsp;&nbsp;
            {{'Ok'|i18n}}
        </button>
    </div>
</ng-template>
